<template>
    <section class="assessmentSection helpSection">
        <div class="pageContent">

            <div class="pageTitle hasSubtitle"
                 v-if="isParent">
                Need some help?
            </div>

            <div class="pageSubtitle"
                 v-if="isParent">
                Here are some common topics that come up when using TRUE Security.
            </div>

            <router-view />

            <hr>
            <div class="helpQuestions">
                <div class="helpQuestions-title">Help Articles</div>
                <router-link class="helpQuestion"
                             to="/assessment/help/what-are-protection-levels">What are protection levels?</router-link>
                <router-link class="helpQuestion"
                             to="/assessment/help/how-do-pets-affect-my-security-system">How do pets affect my security system?</router-link>
                <router-link class="helpQuestion"
                             to="/assessment/help/what-does-accessibility-mean">What does accessibility mean?</router-link>
                <router-link class="helpQuestion"
                             to="/assessment/help/what-is-adt-pulse">What is ADT Pulse?</router-link>
                <router-link class="helpQuestion"
                             to="/assessment/help/what-is-total-level-protection">What is Total Level protection?</router-link>
                <router-link class="helpQuestion"
                             to="/assessment/help/what-are-pet-alleys">What are Pet Alleys?</router-link>
                <router-link class="helpQuestion"
                             to="/assessment/help/indoor-camera-guide">Indoor camera guide</router-link>
                <router-link class="helpQuestion"
                             to="/assessment/help/remote-door-lock-guide">Remote door lock guide</router-link>
                <router-link class="helpQuestion"
                             to="/assessment/help/smoke-communicator-guide">Smoke Communicator guide</router-link>
                <router-link class="helpQuestion"
                             to="/assessment/help/carbon-monoxide-communicator-guide">Carbon Monoxide Communicator guide</router-link>
                <router-link class="helpQuestion"
                             to="/assessment/help/what-is-true-advice">What is True Advice?</router-link>
            </div>

        </div>
    </section>
</template>

<script>
import {
    mapState
} from 'vuex'
export default {
    data() {
        return {
            questions: [{
                    question: "What are protection levels?",
                    answer: "There are three ways to protect your home, Essential, Enhanced, and Total. Using these three levels we can better understand what kind of protection your are looking for. ",
                    expanded: false,
                },
                {
                    question: "How do pets affect my security system?",
                    answer: "Dogs and cats can trip motion sensors when your system is armed. Motion sensors work by creating a monitored area, when something moves in that area the motion sensor is activated. Dogs under 80 lbs tend to stay under this protected area while dogsd over 80 lbs will typically fall into this area. Cat’s on the other hand like tend to jump on top of furniture, putting them in that protected zone. ",
                    expanded: false,
                },
                {
                    question: "Why do my concerns matter?",
                    answer: "",
                    expanded: false,
                },
                {
                    question: "What does accessibility mean?",
                    answer: "Accessibility is a term we use to describe if a window or room can be entered from the outside. Your windows or rooms are accessible if they are at least 13 ft from the ground, or if someone can climb to reach the window.",
                    expanded: false,
                },
                {
                    question: 'What is True Advice?',
                    answer: ""
                }
            ]
        }
    },
    computed: {
        ...mapState(['lead']),

        isParent() {
            return this.$route.path === '/assessment/help' || this.$route.path === '/assessment/help/'
        }
    },
    methods: {
        toggleQuestion(question) {
            question.expanded = !question.expanded
        }
    },
    mounted() {
        this.$refs.focusInput.focus()
        mixpanel.track('inspectedHelpPage')
        gtag('event', 'conversion', { 'send_to': 'AW-879819493/s4buCIKHgoMBEOX1w6MD' });

    }
}

</script>

<style lang="css">


</style>
